import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.use(ElementUI,{ size: 'small' })
// 全局变量
Vue.prototype.$baseUrl = process.env.VUE_APP_BASEURL

import '@/assets/css/global.css'
import '@/assets/css/iconfont/iconfont.css'
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
